<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>Licence manager</span>
    <mat-icon (click)="openInfoDialog()">info</mat-icon>
  </mat-toolbar-row>
</mat-toolbar>

<ng-container *ngIf="progressRef.state | async; let state">
  <div class="sr-progress-spinner" *ngIf="state.active">
    <mat-spinner *ngIf="state.active" [value]="state.value"></mat-spinner>
  </div>
</ng-container>

<router-outlet></router-outlet>
